<template>
  <div>
    <div class="loading-container" v-if="loading">
      <a-spin tip="Loading..." />
    </div>

    <a-form-model
      :model="post"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
      :rules="formRules"
      v-else
    >
      <a-alert type="error" :message="errorMessage" banner v-if="errorMessage != ''" />

      <a-form-model-item :wrapper-col="{ span: 6, offset: 17 }">
        <a-button @click.prevent="saveChanges" type="primary">Save</a-button>
      </a-form-model-item>

      <a-form-model-item label="Title" prop="title">
        <a-input v-model="post.title" />
      </a-form-model-item>

      <a-form-model-item label="Game" prop="game">
        <a-select v-model="post.game" placeholder="Select the game of this post">
          <a-select-option v-for="game in games" :key="game.id" :value="game.name">{{game.name}}</a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item label="Picture">
        <input type="file" name="postPicture" id="postPicture" />
      </a-form-model-item>

      <a-form-model-item label="Content" prop="content">
        <vue-editor
          id="editor"
          useCustomImageHandler
          @image-added="handleImageAdded"
          v-model="post.content"
        ></vue-editor>
      </a-form-model-item>
    </a-form-model>
  </div>
</template>

<script>
import { VueEditor } from "vue2-editor";
import firebase from "@/configs/firebase-setup";

const storage = firebase.storage().ref();
const db = firebase.firestore();

export default {
  data() {
    return {
      loading: false,
      headers: {
        authorization: "authorization-text"
      },
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      post: {
        title: "",
        game: "",
        content: ""
      },
      games: [],
      formRules: {
        title: [
          {
            required: true,
            message: "Title field cannot be empty.",
            trigger: "blur"
          }
        ],
        game: [
          {
            required: true,
            message: "Gamge field cannot be empty.",
            trigger: "blur"
          }
        ],

        content: [
          {
            required: true,
            message: "Content field cannot be empty.",
            trigger: "blur"
          }
        ]
      },

      errorMessage: ""
    };
  },

  created() {
    this.getGamesList();
  },
  methods: {
    async getGamesList() {
      try {
        const docs = await db.collection("games").get();

        docs.forEach(doc => {
          const game = doc.data();
          game.id = doc.id;
          this.games.push(game);
        });
      } catch (error) {
        console.log(error);
      }
    },
    async saveChanges() {
      try {
        // save picture
        const image = document.getElementById("postPicture");
        if (image == null) {
          // show alert
          return;
        }

        // check if fields are empty
        this.errorMessage = "";
        if (
          this.post.title == "" ||
          this.post.game == "" ||
          this.post.content == ""
        ) {
          this.errorMessage = "Please fill all required fields.";
        }

        this.loading = true;
        const today = new Date();

        this.post.created_at = today.toISOString();
        const result = await db.collection("posts").add(this.post);

        const file = image.files[0];
        await storage.child(`images/posts/${result.id}/${this.id}`).put(file);

        this.$router.push({ name: "PostsList" });
      } catch (error) {
        console.log(error);
        this.loading = false;
      }
    },
    handleUploadChange(info) {
      if (info.file.status !== "uploading") {
        console.log(info.file, info.fileList);
      }
      if (info.file.status === "done") {
        this.$message.success(`${info.file.name} file uploaded successfully`);
        console.log(info);
      } else if (info.file.status === "error") {
        this.$message.error(`${info.file.name} file upload failed.`);
      }
    },

    handleImageAdded(file, Editor, cursorLocation, resetUploader) {
      storage
        .child(`images/posts/${this.id}/${file.name}`)
        .put(file)
        .then(async snapshot => {
          const imgUrl = await snapshot.ref.getDownloadURL();
          Editor.insertEmbed(cursorLocation, "image", imgUrl);
        })
        .catch(err => {
          console.log(err);
        });
    }
  },

  components: {
    VueEditor
  }
};
</script>

<style scoped>
.loading-container {
  text-align: center;
  /* background: rgba(0, 0, 0, 0.05); */
  margin-bottom: 20px;
  padding: 30px 50px;
  margin: 20px 0;
}
</style>